import { render } from "./TheCoSoDuoc.vue?vue&type=template&id=47d46fdc"
import script from "./TheCoSoDuoc.vue?vue&type=script&lang=js"
export * from "./TheCoSoDuoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__